import { RootState } from "../../typescript/redux";

export const getState = (state: RootState) => state.timesheets;

export const getTimesheets = (state: RootState) => state.timesheets.list;
